import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export function PartyMembershipCleanupSheet({
  action,
  onConfirm,
  onCancel,
  pending,
  error,
  memberNames,
  createdAt,
  joinedAt,
}: {
  action: "leave" | "disband";
  onConfirm: () => void;
  onCancel: () => void;
  pending: boolean;
  error: string | null;
  memberNames: string[];
  createdAt: string | null;
  joinedAt: string | null;
}) {
  const isDisband = action === "disband";
  const title = isDisband ? "Disband party" : "Leave party";

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={() => {
        if (!pending) onCancel();
      }}
      aria-labelledby="party-cleanup-title"
      aria-describedby="party-cleanup-description"
      slotProps={{ paper: { role: "alertdialog" } }}
      sx={{ "& .MuiButton-root.Mui-disabled": { pointerEvents: "auto" } }}
    >
      <DialogTitle id="party-cleanup-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="party-cleanup-description">
          {isDisband
            ? "This removes everyone from this party."
            : "This removes you from this party."}{" "}
          {memberNames.length
            ? `Party members: ${memberNames.join(", ")}.`
            : "Party roster unavailable."}
          {createdAt ? ` Created ${createdAt}.` : ""}
          {joinedAt && joinedAt !== createdAt ? ` Joined ${joinedAt}.` : ""}
        </DialogContentText>
        {error ? (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onCancel} disabled={pending}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={pending}
        >
          {pending ? (isDisband ? "Disbanding…" : "Leaving…") : title}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
